<template>
  <div class="Address">
    <van-popup v-model="showPopup" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="3"
        @change="onChangeAddress"
        @cancel="showPopup = false"
        @confirm="onConfirmAddress"
        :value="params.district_id + ''"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: {
    from: {
      type: String,
      default: "AddressEdit"
    }
  },
  data() {
    return {
      showPopup: false,
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      /**
       * params
       * province_id 省id
       * city_id 市id
       * district_id 区id
       */
      params: {
        province_id: "",
        city_id: "",
        district_id: ""
      },
      district: [],
      city: "", //全称
      name: {
        province_name: "",
        city_name: "",
        district_name: ""
      }
    };
  },
  methods: {
    onConfirmAddress(val) {
      this.showPopup = false;
      let district_id = "";
      this.district.forEach(item => {
        if (item.num_str == val[2].code) {
          district_id = item.id;
        }
      });
      this.params.province_id = val[0].code;
      this.params.city_id = val[1].code;
      this.params.district_id = district_id;
      this.city = val[0].name + val[1].name + val[2].name;
      this.all_val = {
        province_id: val[0].code,
        city_id: val[1].code,
        district_id: district_id,
        province_name: val[0].name,
        city_name: val[1].name,
        district_name: val[2].name
      };
      this.$emit("setAddress", this.params);
    },
    async onChangeAddress(picker, data, index) {
      switch (index) {
        case 0: // province
          {
            const province = await this.$http.get(
              `/api/app/sonArea/${data[index].code}`
            );
            let obj = {};
            province.forEach(i => {
              obj[i.id] = i.area_name;
            });
            this.areaList.city_list = obj;
            await this.requestDistrict(province[0].id);
          }
          break;
        case 1: // city
          {
            await this.requestDistrict(data[index].code);
          }
          break;
        case 2: // county
          break;
      }
    },
    async requestArea(params) {
      if (params) {
        for (let i in this.params) {
          if (params[i]) this.params[i] = params[i];
        }
      }
      let obj = {};
      const province = await this.$http.get("/api/app/sonArea/0");
      province.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.province_list = obj;
      const provinceID = this.params.province_id || province[0].id;
      const city = await this.$http.get(`/api/app/sonArea/${provinceID}`);
      obj = {};
      city.forEach(i => {
        obj[i.id] = i.area_name;
      });
      this.areaList.city_list = obj;
      const cityID = this.params.city_id || city[0].id;
      await this.requestDistrict(cityID);
      if (
        this.from == "Info" &&
        !this.params.district_id &&
        this.district.length
      ) {
        this.params.district_id = this.district[0].id;
      }
      this.showPopup = true;
    },
    // 针对区id 无法保持前四位一直重新排序
    async requestDistrict(cityID) {
      const district = await this.$http.get(`/api/app/sonArea/${cityID}`);
      let obj = {};
      district.forEach((i, idx) => {
        let num_str = (cityID + "").substring(0, 4);
        let num_idx = "";
        if (idx < 10) {
          num_idx = "0" + idx;
        } else {
          num_idx = idx;
        }
        num_str = Number(num_str + num_idx);
        obj[num_str] = i.area_name;
        i.num_str = num_str;
        // 处理后台返回的区县id与重新排序一直
        if (
          this.params.district_id &&
          i.id == this.params.district_id &&
          this.params.district_id != i.num_str
        ) {
          this.params.district_id = i.num_str;
        }
      });
      this.district = district;
      this.areaList.county_list = obj;
    }
  }
};
</script>

<style scoped></style>
